import React from 'react';
import { Box, Text, Flex } from '@chakra-ui/react';

interface UsageProgressProps {
  label: string;
  value: number;
  total: number;
  variant?: 'primary' | 'secondary';
}

export const UsageProgress: React.FC<UsageProgressProps> = ({
  label,
  value,
  total,
  variant = 'primary'
}) => {
  const percentage = total > 0 ? (value / total) * 100 : 0;
  
  const getProgressColors = () => {
    if (variant === 'primary') {
      return {
        bg: '#E2E8F0', // gray.200
        fill: '#7C3AED' // purple.600
      };
    } else {
      // For cached items - gradient from purple to pink/red
      return {
        bg: '#E2E8F0',
        fill: 'linear-gradient(90deg, #7C3AED 0%, #EC4899 100%)' // purple to pink gradient
      };
    }
  };

  const colors = getProgressColors();

  return (
    <Box>
      <Flex justify="space-between" align="center" mb={2}>
        <Text color="gray.800">
          {label}
        </Text>
        <Text color="gray.800" fontWeight="medium">
          {value === 0 && total === 0 
            ? 'No data available' 
            : `${value.toLocaleString()} of ${total.toLocaleString()}`
          }
        </Text>
      </Flex>
      <Box
        height="8px"
        bg={colors.bg}
        borderRadius="full"
        overflow="hidden"
      >
        <Box
          height="100%"
          width={`${Math.min(percentage, 100)}%`}
          background={colors.fill}
          borderRadius="full"
          transition="width 0.3s ease"
        />
      </Box>
    </Box>
  );
};
